import {Checkbox, CheckboxIcon, CheckboxIndicator} from "@hosttools/frontend";
import {type HeaderContext} from "@tanstack/react-table";
import type React from "react";
import {useCallback} from "react";

const TableCheckBoxHeader: React.FC<HeaderContext<any, any>> = ({table}) => {
    return (
        <Checkbox
            isChecked={table.getIsAllRowsSelected()}
            isIndeterminate={table.getIsSomeRowsSelected()}
            value="header"
            onChange={useCallback((value: boolean) => table.toggleAllRowsSelected(value), [table])}
        >
            <CheckboxIndicator>
                <CheckboxIcon />
            </CheckboxIndicator>
        </Checkbox>
    );
};

// putting `memo` might cause error here due to `table` value
export default TableCheckBoxHeader;
